<template>
    <app-page-error v-if="showErrorPage" />

    <div v-else id="projectContainer" class="is-clipped pt-3 lb-full-height">
        <transition
            enter-active-class="animated slideInRight"
            leave-active-class="animated slideOutRight"
            mode="out-in"
        >
            <project-configuration
                v-if="showMenu"
                :items="filteredItems"
                ref="configuration"
                @openObject="openDetail"
                @centerMap="centerMap"
            />
        </transition>

        <div class="columns mx-0">
            <div
                v-if="showMenu"
                :class="{ 'project-content-modal': !objectListShowed }"
                @click="$store.dispatch('Project/hideMenu')"
            >
                <div class="modal-background" v-if="!objectListShowed"></div>
            </div>

            <project-header
                :session-creation.sync="showCreateSessionModal"
                :session-simulation.sync="showSimulateSessionModal"
                :show-sessions.sync="showSessions"
                :show-configuration.sync="showSettings"
                class="is-hidden-tablet"
            />

            <div
                class="
                    lb-project-menu lb-full-height
                    has-scroll-y
                    is-scroll-hidden is-hidden-mobile
                "
            >
                <button
                    v-if="project.type != 'treasurehunt'"
                    :disabled="!hasCreationPermission"
                    class="button is-ghost"
                    @click="enableCreation"
                >
                    <span class="icon is-medium has-text-primary">
                        <i class="mdi mdi-30px mdi-plus-circle"></i>
                    </span>
                </button>
                <p
                    v-if="project.type != 'treasurehunt'"
                    v-t="'project.add_content'"
                    class
                ></p>

                <button
                v-if="project.type != 'treasurehunt' && hasMap"
                    class="button is-ghost"
                    @click="$store.dispatch('Project/toggleObjectList')"
                >
                    <span class="icon is-medium has-text-primary">
                        <i class="mdi mdi-30px mdi-view-list"></i>
                    </span>
                </button>
                <p
                    v-if="project.type != 'treasurehunt' && hasMap"
                    v-t="'project_show_object_list'"
                    class
                ></p>

                <button
                    :disabled="!isLoggedIn"
                    class="button mt-2 is-ghost"
                    @click="$store.dispatch('Project/toggleComments')"
                >
                    <span class="icon is-medium has-text-primary">
                        <i class="mdi mdi-30px mdi-message-text-outline"></i>
                    </span>
                    <span
                        v-if="project.pendingComments"
                        class="badge lb-project-header-badge"
                        >{{ project.pendingComments }}</span
                    >
                </button>
                <p v-t="'project_commments_option'" class></p>

                <div v-if="isTrivial && !this.$store.getters.isAnonymous">
                    <button
                        :disabled="!hasCreationPermission"
                        class="button mt-2 is-ghost"
                        @click="showingAnswers = !showingAnswers"
                    >
                        <span class="icon is-medium has-text-primary">
                            <i class="mdi mdi-30px mdi-table-eye"></i>
                        </span>
                    </button>
                    <p v-t="'project.showAnswers'" class></p>
                </div>

                <div v-if="$store.getters.canCreateSessions">
                    <!--<button class="button mt-2 is-ghost" @click="showCreateSessionModal = true">
                        <span class="icon is-medium has-text-primary">
                            <i class="mdi mdi-30px mdi-controller-classic"></i>
                        </span>
                    </button>
                    <p v-t="'project.create_session'" class></p>-->

                    <button
                        class="button mt-2 is-ghost"
                        @click="startSimulation"
                    >
                        <span class="icon is-medium has-text-primary">
                            <i class="mdi mdi-30px mdi-cellphone-wireless"></i>
                        </span>
                    </button>
                    <p v-t="'project.simulate_session'" class></p>

                    <button
                        v-if="!this.$store.getters.isAnonymous"
                        class="button mt-2 is-ghost"
                        @click="mySessions"
                    >
                        <span class="icon is-medium has-text-primary">
                            <i class="mdi mdi-30px mdi-trophy"></i>
                        </span>
                    </button>
                    <p
                        v-if="!this.$store.getters.isAnonymous"
                        v-t="'project_own_session_option'"
                        class
                    ></p>

                    <button
                        v-if="!this.$store.getters.isAnonymous"
                        class="button mt-2 is-ghost"
                        @click="showCreateSessionModal = true"
                    >
                        <span class="icon is-medium has-text-primary">
                            <i class="mdi mdi-30px mdi-controller-classic"></i>
                        </span>
                    </button>
                    <p
                        v-if="!this.$store.getters.isAnonymous"
                        v-t="'project.create_session'"
                        class
                    ></p>
                </div>

                <!--<div v-if="hasAdminPermission">
                    <button
                        class="button mt-2 is-ghost"
                        @click="$store.dispatch('Project/toggleParticipants')"
                    >
                        <span class="icon is-medium has-text-primary">
                            <i class="mdi mdi-30px mdi-account-multiple"></i>
                        </span>
                    </button>
                    <p v-t="'project_participants_option'" class></p>
                </div>-->

                <div v-if="hasAdminPermission">
                    <!-- to render icon properly-->
                    <button
                        class="button mt-2 is-ghost"
                        @click="$store.dispatch('Project/togglePrivacy')"
                    >
                        <span class="icon is-medium has-text-primary">
                            <i class="mdi mdi-30px mdi-lock"></i>
                        </span>
                    </button>
                    <p v-t="'project_access_option'" class></p>
                </div>

                <div v-if="hasEditionPermission">
                    <button
                        class="button mt-2 is-ghost"
                        @click="$store.dispatch('Project/toggleChanges')"
                    >
                        <span class="icon is-medium has-text-primary">
                            <i class="mdi mdi-30px mdi-history"></i>
                        </span>
                        <span
                            v-if="project.pendingChanges"
                            class="badge lb-project-header-badge"
                            >{{ project.pendingChanges }}</span
                        >
                    </button>
                    <p v-t="'project_history_option'" class></p>
                </div>

                <div v-if="hasAdminPermission">
                    <button
                        class="button mt-2 is-ghost"
                        @click="showSettings = true"
                    >
                        <span class="icon is-medium has-text-primary">
                            <i class="mdi mdi-30px mdi-cog"></i>
                        </span>
                    </button>
                    <p v-t="'project_configuration_option'" class></p>
                </div>

                <div v-if="hasAdminPermission">
                    <button
                        class="button mt-2 is-ghost"
                        @click="showNotifications = true"
                    >
                        <span class="icon is-medium has-text-primary">
                            <i class="mdi mdi-30px mdi-bell-ring"></i>
                        </span>
                    </button>
                    <p v-t="'project_configuration_notifications'" class></p>
                </div>

                <div>
                    <button class="button mt-2 is-ghost" @click="shareProject">
                        <span class="icon is-medium has-text-primary">
                            <i class="mdi mdi-30px mdi-share-variant"></i>
                        </span>
                    </button>
                    <p v-t="'Object.share'" class></p>
                </div>
            </div>

            <div
                :class="hasMap ? 'px-0 py-0' : 'px-3 py-2'"
                class="default-theme column is-11"
            >
                <div
                    :class="hasMap ? 'is-absolute-z1 px-3 py-0' : ''"
                    class="columns"
                >
                    <div :class="hasMap ? 'is-12' : 'is-4'" class="column">
                        <app-search-bar
                            :placeholder="$t('search_text')"
                            :filter.sync="typeFilter"
                            :text.sync="searchValue"
                            class="mt-3"
                            @input="searchObjects"
                        />
                    </div>
                </div>

                <project-content-map
                    v-if="hasMap"
                    ref="mapContainer"
                    :items="filteredItems"
                    @click="openDetail"
                />

                <component
                    :is="cardsComponent"
                    v-if="!hasMap"
                    ref="content"
                    :project-id="projectId"
                    :items="filteredItems"
                    :draft="contentDraft"
                    :modal-opened="showInputModal"
                    :show-answers="showingAnswers"
                    class="column is-12 is-paddinglesss"
                    @click="openDetail"
                    @enable-creation="enableCreation"
                    @add-element="openModal"
                    @create-object="createObject"
                    @update-object="updateObject"
                    @edit-object="editObject"
                    @delete-object="deleteObject"
                    @cancel="cancelInput"
                />
            </div>

            <router-view />

            <project-modal-settings
                v-if="showSettings"
                :project-source="project"
                class="lb-project-settings-modal"
                @close="showSettings = false"
            />

            <project-modal-notifications
                v-if="showNotifications"
                :project-source="project"
                class="lb-project-settings-modal"
                @close="showNotifications = false"
            />

            <project-modal-sessions
                v-if="showSessions"
                :project-source="project"
                class="lb-project-settings-modal"
                @close="showSessions = false"
                @create-session="
                    showCreateSessionModal = true;
                    showSessions = false;
                "
            />

            <projectSessionCreationModal
                v-if="showCreateSessionModal"
                @close="showCreateSessionModal = false"
                @detail="showSessionDetailModal = true"
            />

            <div v-if="showSimulateSessionModal" class="is-clipped">
                <div class="modal-background has-scroll-y">
                    <component
                        :is="simulatePlayComponent"
                        @close="showSimulateSessionModal = false"
                    />
                </div>
            </div>

            <projectSessionDetailsModal
                v-if="showSessionDetailModal"
                @close="showSessionDetailModal = false"
            />

            <project-modal-creation
                v-if="creationEnabled"
                :draft="contentDraft"
                :has-location="hasMap"
                @click.stop
                @close="cancelInput"
                @add-element="openModal"
                @create-object="createObject"
                @update-object="updateObject"
                @edit-object="editObject"
                @delete-object="deleteObject"
            />

            <input-modal
                v-if="showInputModal"
                v-model="contentDraft[contentProperty]"
                :active.sync="showInputModal"
                :component-type="componentType"
                :locations="locations"
                :from-clipboard="fromClipboard"
                @input="
                    showInputModal = false;
                    fromClipboard = false;
                "
                @cancel="cancelFromModal"
            />
        </div>
    </div>
</template>

<script>
import ProjectHeader from '@/components/ProjectHeader';
import ProjectContent from '@/components/ProjectContent';
import ProjectContentTreasureHunt from '@/components/ProjectContentTreasureHunt';
import ProjectContentMap from '@/components/ProjectContentMap';
import ProjectConfiguration from '@/components/ProjectConfiguration';
import ProjectModalSettings from '@/components/ProjectModalSettings';
import ProjectModalSessions from '@/components/ProjectModalSessions';
import ProjectSessionCreationModal from '@/components/ProjectSessionCreationModal';
import ProjectSessionDetailsModal from '@/components/ProjectSessionDetailsModal';
import ProjectNavControls from '@/components/ProjectNavControls';
import InputModal from '@/components/InputModal';
import ProjectModalCreation from '@/components/ProjectModalCreation';
import AppPageError from '@/components/AppPageError';
import AppSearchBar from '@/components/AppSearchBar';
import PlayQuiz from '@/components/PlayQuiz';
import PlayTreasureHunt from '@/components/PlayTreasureHunt';
import store from '@/store/index';
import { SECRET } from '@/lib/constants';
import { Document } from 'flexsearch';
import _ from 'underscore';
import { Splitpanes, Pane } from 'splitpanes';
import { isEmptyObject } from '@/lib/helpers';
import ProjectModalNotifications from '@/components/ProjectModalNotifications';
import moment from 'moment';
export default {
    name: 'Project',
    components: {
        ProjectHeader,
        ProjectContent,
        ProjectContentTreasureHunt,
        ProjectContentMap,
        ProjectConfiguration,
        Splitpanes,
        Pane,
        ProjectModalSettings,
        ProjectModalSessions,
        ProjectSessionCreationModal,
        ProjectSessionDetailsModal,
        ProjectNavControls,
        InputModal,
        ProjectModalCreation,
        AppPageError,
        AppSearchBar,
        ProjectModalNotifications,
    },
    beforeRouteUpdate(to, from, next) {
        if (to.params.edit == true) {
            this.editObject(_.findWhere(this.items, { _id: to.params.object }));
        }
        next((vm) => {
            console.log('finished route update');
            vm.$Progress.finish();
        });
    },
    beforeRouteLeave(to, from, next) {
        const hasChanges = this.$refs.configuration
            ? this.$refs.configuration.hasChanges
            : false;
        if (
            hasChanges &&
            !confirm(this.$t('project.discard_unsaved_changes'))
        ) {
            next(false);
        } else {
            next();
        }
    },
    props: {
        projectId: { type: String, default: undefined },
    },
    metaInfo() {
        // if no subcomponents specify a metaInfo.title, this title will be used
        return {
            title: this.project.title,
            titleTemplate: '%s - Labylok',
            meta: [
                // Twitter Card
                { name: 'twitter:card', content: 'summary' },
                { name: 'twitter:title', content: this.project.title },
                {
                    name: 'twitter:description',
                    content: this.project.description,
                },
                // image must be an absolute path
                { name: 'twitter:image', content: this.projectBackgroundImage },
                // Facebook OpenGraph
                { property: 'og:title', content: this.project.title },
                { property: 'og:site_name', content: 'Labylok' },
                { property: 'og:type', content: 'website' },
                { property: 'og:image', content: this.projectBackgroundImage },
                {
                    property: 'og:description',
                    content: this.project.description,
                },
            ],
        };
    },
    data() {
        return {
            searchValue: '',
            typeFilter: this.$t('Constants.FILTER_OPTION_ALL'),
            searchDropdownOptions: [
                this.$t('Constants.FILTER_OPTION_ALL'),
                this.$t('Constants.FILTER_OPTION_MINE'),
                this.$t('Constants.FILTER_OPTION_MENTIONED'),
                this.$t('Constants.FILTER_OPTION_COMMENTED'),
                this.$t('Constants.FILTER_OPTION_LIKED'),
            ],
            selectedItem: {},
            contentDraft: { owner: {} },
            creationEnabled: false,
            creating: false,
            searchIndex: new Document({
                resolution: 3,
                tokenize: 'full',
                document: {
                    id: '_id',
                    index: [
                        {
                            field: 'title',
                            minlength: 0,
                        },
                        {
                            field: 'description',
                            minlength: 0,
                        },
                        {
                            field: 'tags',
                            minlength: 0,
                        },
                        'owner:name',
                        'owner:email',
                    ],
                },
            }),
            eventSource: undefined,
            showSettings: false,
            showSessions: false,
            showCreateSessionModal: false,
            showSessionDetailModal: false,
            showMapCreation: false,
            showInputModal: false,
            componentType: undefined,
            fromClipboard: false,
            items: this.$store.getters.projectContent || [],
            logo: process.env.ROOT_PATH + require('@/assets/images/logo.png'),
            showErrorPage: false,
            renderMap: true,
            showingAnswers: false,
            showSimulateSessionModal: false,
            session: {},
            originalItem: {},
            showNotifications: false,
            showObjectList: false,
        };
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        activeView() {
            return this.$store.getters.project.mode || 'panel';
        },
        hasMap() {
            return (
                this.$store.getters.project.mode == 'map' &&
                (this.$mq != 'mobile' || this.renderMap)
            );
        },
        renderMapControl() {
            return (
                this.$store.getters.project.mode == 'map' &&
                this.$mq == 'mobile'
            );
        },
        showMenu() {
            return this.$store.getters['Project/showMenu'];
        },
        cardPaneMinSize() {
            if (this.$mq == 'mobile') {
                return 100;
            } else return 25;
        },
        mapPaneMinSize() {
            if (this.$mq == 'mobile') {
                return this.renderMap ? 100 : 0;
            } else return 50;
        },
        mapPaneMaxSize() {
            if (this.$mq == 'mobile') {
                return this.renderMap ? 100 : 0;
            } else return 75;
        },
        project() {
            return this.$store.getters.project;
        },
        itemsSource() {
            return this.$store.getters.projectContent;
        },
        projectBackgroundImage() {
            return this.$store.getters.projectImage || this.logo;
        },
        cardsComponent() {
            if (this.project.type == 'treasurehunt') {
                return ProjectContentTreasureHunt;
            } else {
                return ProjectContent;
            }
        },
        simulatePlayComponent() {
            if (this.$store.getters.project.type == 'treasurehunt') {
                return PlayTreasureHunt;
            } else {
                return PlayQuiz;
            }
        },
        filteredItems() {
            let items;
            this.searchIndex.remove(this.items);
            switch (this.typeFilter) {
                case this.$t('Constants.FILTER_OPTION_MINE'):
                    items = this.items.filter((item) => {
                        return (
                            item.owner.owner == this.$store.getters.user.owner
                        );
                    });
                    break;
                case this.$t('Constants.FILTER_OPTION_COMMENTED'):
                    items = this.items.filter((item) => {
                        return _.some(item.comments, (comment) => {
                            return (
                                comment.owner.owner ==
                                this.$store.getters.user.owner
                            );
                        });
                    });
                    break;
                case this.$t('Constants.FILTER_OPTION_MENTIONED'):
                    items = this.items.filter((item) => {
                        return _.some(item.comments, (comment) => {
                            if (!comment.message) {
                                return false;
                            }
                            return (
                                comment.message.indexOf(
                                    '@' + this.$store.getters.user.username
                                ) > -1
                            );
                        });
                    });
                    break;
                case this.$t('Constants.FILTER_OPTION_LIKED'):
                    items = this.items.filter((item) => {
                        return item.liked;
                    });
                    break;
                default:
                    items = this.items;
            }
            if (this.searchValue) {
                this.searchIndex.add(items);
                const result = this.searchIndex.search(this.searchValue);
                const ids = _.chain(result).pluck('result').flatten().value();
                return this.items.filter((item) => {
                    return _.contains(ids, item._id);
                });
            }
            return items;
        },
        hasCreationPermission() {
            return (
                this.$store.getters.isLoggedIn &&
                this.$store.getters.project.accessLevel != 'read'
            );
        },
        hasEditionPermission() {
            return (
                this.$store.getters.isLoggedIn &&
                this.$store.getters.project.accessLevel != 'read' &&
                this.$store.getters.project.accessLevel != 'create'
            );
        },
        hasAdminPermission() {
            return this.$store.getters.project.accessLevel == 'administrator';
        },
        contentProperty() {
            switch (this.componentType) {
                case 'image': {
                    return 'images';
                }
                case 'answer': {
                    return 'answers';
                }
                case 'map': {
                    return 'location';
                }
                default:
                    return this.componentType;
            }
        },
        isTrivial() {
            return this.project.type == 'trivial';
        },
        isGeoquiz() {
            return this.project.type == 'trivial' && this.project.mode == 'map';
        },
        correctAnswers() {
            return _.filter(this.contentDraft.answers, (answer) => {
                if (answer.correct) {
                    return answer && answer.value;
                }
            });
        },
        cleanedAnswers() {
            return _.filter(this.contentDraft.answers, (answer) => {
                if (answer.value) {
                    return answer;
                }
            });
        },
        simulatedSession() {
            let sessionData = {
                configuration: {
                    mode: this.isTrivial != false ? 'TRIVIAL' : 'MAP',
                    time: 2,
                    timeUnits: 'minutes',
                    feedback: '',
                },
                project: this.$store.getters.project,
                title: `Juego de preguntas sobre ${this.$store.getters.project.title}`,
                allowsReset: false,
                session_answers: [],
                simulation: true,
            };
            if (this.$store.getters.project.type == 'treasurehunt') {
                console.log('treasurehunt sumulation');
                let treasurehuntContent = [];
                let items = [...this.filteredItems];
                for (let item of items) {
                    // console.log(_.keys(item.triggers)[0]);
                    if (_.keys(item.triggers)[0] == 'GO_TO_POINT') {
                        /*console.log(
                            'search point',
                            item.triggers[_.keys(item.triggers)[0]]
                        );*/
                        let pointData = _.findWhere(items, {
                            _id: item.triggers[_.keys(item.triggers)[0]],
                        });
                        // console.log('pointData', pointData);
                        item.location = pointData.location;
                        item.triggers = pointData.triggers;
                        // console.log('item', item);
                        treasurehuntContent.push(item);
                    } else if (
                        _.keys(item.triggers)[0] != 'ON_ARRIVE' &&
                        _.keys(item.triggers)[0] != 'GO_TO_POINT'
                    ) {
                        if (item.triggers[_.keys(item.triggers)[0]] == '') {
                            item.triggers = { END: '' };
                        }
                        treasurehuntContent.push(item);
                    }
                }
                // console.log('treasure hunt content', treasurehuntContent);
                sessionData.context = treasurehuntContent;
            } else {
                sessionData.context = this.filteredItems;
            }
            return sessionData;
        },
        objectListShowed() {
            return this.$store.getters['Project/showObjectList'];
        },
    },
    watch: {
        activeView(viewMode) {
            this.resize();
        },
        items: {
            handler: function () {
                this.items.forEach((item) => {
                    this.searchIndex.add(item);
                });
                //this.searchIndex.add(this.items)
            },
            immediate: true,
        },
        itemsSource() {
            this.items = this.itemsSource;
        },
    },
    mounted: function () {
        store
            .dispatch('fetchProject', this.$route.params.projectId)
            .catch((e) => {
                console.error('failed to fetch project', e.status || e);
                this.showErrorPage = true;
            });

        setTimeout(() => {
            this.$Progress.start();
        }, 500);

        store
            .dispatch('fetchProjectContent', {
                _id: this.$route.params.projectId,
            })
            .catch(() => {
                console.error('failed to fetch project content');
            })
            .finally(() => {
                this.$Progress.finish();
                const projectDate = moment(
                    this.$store.getters.project.modified
                );
                const nowDate = moment();
                const diffMinutes = nowDate.diff(projectDate, 'minutes');
                //console.log(this.$store.getters.projectContent.length,diffMinutes,this.$store.getters.project.accessLevel == 'administrator')
                if (
                    !this.$store.getters.projectContent.length &&
                    diffMinutes < 2 &&
                    this.$store.getters.project.accessLevel == 'administrator'
                ) {
                    this.showSettings = true;
                }
                if (
                    !this.isLoggedIn &&
                    (this.project.privacy == 'secret' ||
                        this.project.privacy == 'public') &&
                    this.project.allowAnonymous
                ) {
                    console.log('dispatching anonymous login');
                    this.$store
                        .dispatch('anonymousLogin', 'anonymous')
                        .then(() => {
                            console.log(this.$store.getters.user);
                        });
                }
            });
        window.addEventListener('paste', this.handlePaste);
        const url = new URL(process.env.VUE_APP_MERCURE_URL);
        url.searchParams.append(
            'topic',
            'http://project.' + this.$route.params.projectId
        );
        this.eventSource = new EventSource(url);
        this.eventSource.onmessage = this.onChangeReceived;
    },
    beforeDestroy() {
        this.eventSource.close();
        window.removeEventListener('paste', this.handlePaste);
    },
    destroyed() {
        this.$store.dispatch('cleanProject');
        if (
            this.$store.getters.isAnonymous &&
            (this.project.privacy == 'secret' ||
                this.project.privacy == 'public') &&
            this.project.allowAnonymous
        ) {
            this.$store.dispatch('logout');
        }
    },

    methods: {
        resize(e) {
            this.$nextTick(() => {
                _.debounce(
                    this.$refs.mapContainer && this.$refs.mapContainer.resize(),
                    100
                );
            });
        },
        openDetail(item) {
            //console.log("in open detail",item)
            const { _id } = item;
            if (this.project.type === 'trivial') {
                let itemToEdit = this.items.filter((object) => {
                    return object._id === item._id;
                });
                // console.log(itemToEdit);
                if (
                    this.hasEditionPermission ||
                    itemToEdit[0].owner.owner == this.$store.getters.user.owner
                ) {
                    let itemToEdit = this.items.filter((object) => {
                        return object._id === item._id;
                    });
                    return this.editObject(itemToEdit[0]);
                } else {
                    return;
                }
            }
            if (!this.creationEnabled) {
                this.$router.push({
                    name: 'object-detail',
                    params: { objectId: _id },
                    query: this.$route.query,
                });
            }
        },
        enableCreation() {
            if (this.creationEnabled) {
                return;
            }
            this.creationEnabled = true;
            this.contentDraft._id = 'draft';
            this.contentDraft.order = this.items.length + 1;
        },
        editObject(item) {
            this.contentDraft = item;
            this.creationEnabled = true;
            this.originalItem = JSON.parse(JSON.stringify(item));
        },
        async deleteObject(_id) {
            if (_id == 'draft') {
                return this.cancelInput();
            }
            if (confirm(this.$t('delete_project_confirmation_message'))) {
                this.$store.dispatch('deleteObject', _id);
                this.items = this.$store.getters.projectContent.filter(
                    function (item) {
                        return item['_id'] != 'draft' && item['_id'] != _id;
                    }
                );
                this.cancelInput();
            }
        },
        async createObject() {
            if (
                !isEmptyObject(
                    _.omit(this.contentDraft, '_id', 'order', 'owner')
                )
            ) {
                if (this.creating == true) {
                    console.log('cancelling input because  is creating');
                    return this.cancelInput();
                }

                if (this.project.type === 'trivial') {
                    const responseValidator = this.questionValidator();
                    if (responseValidator !== 'ALL_OK') {
                        alert(this.$t(responseValidator));
                        return;
                    }
                }
                this.creating = true;
                if (this.items.length > 1) {
                    this.contentDraft.order = this.items.length;
                } else {
                    this.contentDraft.order = 1;
                }

                await this.$store
                    .dispatch('createObject', {
                        ...this.contentDraft,
                        ...{ project: this.$route.params.projectId },
                    })
                    .catch((e) => {
                        console.error('error creatiorn', e);
                        this.creating = false;
                    });

                this.creating = false;
                this.showCreation = false;
                this.items = this.$store.getters.projectContent.filter(
                    function (item) {
                        return item['_id'] != 'draft';
                    }
                );
            } else {
                this.cancelInput();
            }
            this.creationEnabled = false;
            this.contentDraft = { owner: {} };
        },
        questionValidator() {
            if (!this.contentDraft.title) {
                return 'Object.errors.FILL_QUESTION';
            }
            if (
                this.contentDraft.answerType == 'HANGMAN' ||
                this.contentDraft.answerType == 'FREETEXT'
            ) {
                if (!this.contentDraft.answers) {
                    return 'Object.errors.FILL_ANSWER';
                }
                if (this.correctAnswers.length) {
                    this.cleanAnswers(); // removes emtpy answers
                    this.contentDraft.answers = [this.correctAnswers[0]]; // ensure only one answer for this question type
                } else {
                    return 'Object.errors.MARK_CORRECT';
                }
            } else {
                if (
                    !this.contentDraft.answers ||
                    !this.contentDraft.answers.length
                ) {
                    return 'Object.errors.FILL_ANSWERS';
                }
                this.cleanAnswers(); // removes emtpy answers
                if (this.correctAnswers.length < 1) {
                    return 'Object.errors.MARK_CORRECT';
                }
            }
            return 'ALL_OK';
        },
        cleanAnswers() {
            this.contentDraft.answers = this.cleanedAnswers;
        },
        updateObject() {
            if (this.project.type === 'trivial') {
                const responseValidator = this.questionValidator();
                if (responseValidator !== 'ALL_OK') {
                    alert(this.$t(responseValidator));
                    return;
                }
            }
            this.$store.dispatch('updateObject', {
                ...this.contentDraft,
            });
            this.creationEnabled = false;
            this.contentDraft = { owner: {} };
        },
        cancelInput() {
            if (this.contentDraft._id == 'draft') {
                this.items = _.without(this.items, this.contentDraft);
            } else {
                const objectIndex = _.findIndex(this.items, {
                    _id: this.contentDraft._id,
                });
                this.items.splice(objectIndex, 1, this.originalItem);
            }

            this.contentDraft = { owner: {} };
            this.originalItem = {};
            this.showCreation = false;
            this.creationEnabled = false;
        },
        openModal(e) {
            this.locations = this.items.filter((item) => {
                if (item._id !== this.contentDraft._id) {
                    return item.location;
                }
            });
            if (!this.showInputModal) {
                this.enableCreation();
            }
            this.showInputModal = true;
            this.componentType = e;
        },
        onChangeReceived(e) {
            const data = JSON.parse(e.data);
            switch (data.type) {
                case 'UPDATE':
                case 'NEW_COMMENT':
                    this.$store.commit('UPDATE_OBJECT', data.object);
                    break;
                case 'CREATE':
                    this.$store.commit('ADD_OBJECT_TO_PROJECT', data.object);
                    break;
                case 'NEW_PROJECT_COMMENT':
                    this.$store.commit('ADD_COMMENT_TO_PROJECT', data.object);
                    break;
                case 'LIKE_PROJECT_COMMENT':
                    this.$store.commit('UPDATE_COMMENT', {
                        _id: data.object._id,
                        comment: data.object,
                    });
                    break;
                case 'NEW_PROJECT_CHANGE':
                    this.$store.commit('ADD_CHANGE_TO_PROJECT', data.object);
                    break;
                case 'DELETE_OBJECT':
                    this.$store.commit('DELETE_OBJECT', data.object);
                    break;
                default:
                    console.log('unhandled event ', data.type || data.message);
            }
        },
        openSettings(project) {
            this.showSettings = true;
        },
        handlePaste(e) {
            this.$store.dispatch('setClipboardContent', e.clipboardData.items);
        },
        searchObjects(text) {
            this.searchValue = text;
            this.filteredItems;
        },
        startSimulation() {
            console.log('in start simulation');
            this.$store
                .dispatch('setSession', this.simulatedSession)
                .catch((e) => {
                    console.log('error setting simulation session');
                });
            this.showSimulateSessionModal = true;
        },
        mySessions() {
            this.showSessions = true;
        },
        cancelFromModal() {
            if (
                this.contentDraft._id == 'draft' &&
                this.componentType == 'location' &&
                this.project.type == 'trivial' &&
                this.project.mode == 'map'
            ) {
                this.showInputModal = false;
                this.cancelInput();
            } else {
                this.showInputModal = false;
            }
        },
        shareProject() {
            this.$parent.showShareModal = true;
        },
        centerMap(item) {
            // console.log('item', item);
            this.$refs.mapContainer.centerMapOnObject(item);
        },
    },
};
</script>

<style scoped lang="css">
@import '~splitpanes/dist/splitpanes.css';
html {
    overflow: auto;
}
.splitpanes__pane {
    background-color: transparent !important;
}
#projectContainer {
    overflow: hidden;
}
.lb-project-header-badge {
    top: 1rem;
    right: 1rem;
    border-radius: 0.5rem;
    height: 1rem;
    widows: 1rem;
    padding: 0.05rem 0.3rem;
}
.lb-project-menu-item {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
}
.is-absolute-z1 {
    position: absolute;
    z-index: 1;
}
.mdi-30px {
    font-size: 30px;
}
</style>
